import { render, staticRenderFns } from "./BoxPerformanceComparisonLine.vue?vue&type=template&id=56afba20&scoped=true&"
import script from "./BoxPerformanceComparisonLine.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonLine.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonLine.vue?vue&type=style&index=0&id=56afba20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56afba20",
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
